import { Link, useLocation } from "react-router-dom";
import { Home, ArrowLeft, Calculator, TrendingUp, Wallet, ArrowRight } from "lucide-react";

export default function HomeButtonSection() {
  const location = useLocation();

  const handleHomeClick = (e: React.MouseEvent) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section className="mt-16 pt-8 border-t border-gray-800/60" id="home-button-section">
      <div className="bg-gradient-to-br from-gray-950/80 to-[#111827]/80 rounded-2xl border border-gray-800/80 p-8 md:p-10 relative overflow-hidden shadow-2xl flex flex-col md:flex-row items-center justify-between gap-8">
        
        {/* Subtle decorative glow */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-64 h-64 bg-amber-500/5 rounded-full blur-[80px] pointer-events-none" />
        <div className="absolute top-1/2 right-0 -translate-y-1/2 w-64 h-64 bg-emerald-500/5 rounded-full blur-[80px] pointer-events-none" />

        {/* Info text & Brand message */}
        <div className="space-y-4 text-left max-w-xl relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-slate-800 text-xs text-amber-400 font-mono">
            <Calculator className="w-3.5 h-3.5 text-amber-400" />
            <span>Interactive Library Directory</span>
          </div>
          <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-white">
            Explore More Financial Calculators
          </h3>
          <p className="text-sm text-gray-400 leading-relaxed font-light">
            USMoneyAI offers 77+ free financial calculators covering loans, mortgages, savings, investments, retirement planning, budgeting, and debt repayment. Browse our tools to find the right calculator for your financial needs.
          </p>
        </div>

        {/* Big Premium CTA Home Buttons */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 shrink-0 w-full md:w-auto relative z-10">
          {/* Main Return Home Button */}
          <Link 
            to="/"
            onClick={handleHomeClick}
            className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-bold text-sm tracking-tight transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 shadow-lg shadow-amber-500/10 focus:outline-none focus:ring-2 focus:ring-amber-500"
          >
            <Home className="w-4.5 h-4.5" />
            <span>Go to Home Dashboard</span>
          </Link>

          {/* Quick back with arrow button */}
          <Link 
            to="/"
            onClick={handleHomeClick}
            className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-slate-900 border border-gray-800 hover:border-gray-750 hover:bg-slate-800/60 text-white font-medium text-sm transition-all duration-300"
          >
            <ArrowLeft className="w-4 h-4 text-gray-400" />
            <span>View All 77+ Tools</span>
          </Link>
        </div>

      </div>

      {/* Popular category tags underneath the section */}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs">
        <span className="text-gray-500 font-mono uppercase tracking-wider">Quick Jump:</span>
        <Link 
          to="/loan-calculator" 
          className="px-4 py-1.5 rounded-full bg-gray-900/40 hover:bg-gray-900 border border-gray-800/80 text-gray-300 hover:text-amber-400 transition-all duration-200"
        >
          Mortgages
        </Link>
        <Link 
          to="/retirement-calculator" 
          className="px-4 py-1.5 rounded-full bg-gray-900/40 hover:bg-gray-900 border border-gray-800/80 text-gray-300 hover:text-amber-400 transition-all duration-200"
        >
          Retirement Planner
        </Link>
        <Link 
          to="/compound-interest-calculator" 
          className="px-4 py-1.5 rounded-full bg-gray-900/40 hover:bg-gray-900 border border-gray-800/80 text-gray-300 hover:text-amber-400 transition-all duration-200"
        >
          Compound Interest
        </Link>
        <Link 
          to="/debt-payoff-calculator" 
          className="px-4 py-1.5 rounded-full bg-gray-900/40 hover:bg-gray-900 border border-gray-800/80 text-gray-300 hover:text-amber-400 transition-all duration-200"
        >
          Debt Payoff
        </Link>
      </div>

    </section>
  );
}
